import React, { useEffect } from "react";
import { ISocket } from "./SocketProvider.types";
import { useAuth } from "../AuthProvider/AuthProvider";
import { SocketContext } from "./SocketProvider.context";
import { LinearProgress, Typography } from "@mui/material";
import { initializeSocket } from "./SocketProvider.utils";
import { LinesheetDocumetAlert } from "./components/LinesheetDocumetAlert";
import { BulkActivationProgress } from "./components/BulkActivationProgress";
import { AlertSnackbar } from "./components/AlertSnackbar";

export const SocketProvider: React.FC<{ children: React.ReactNode }> = (
  props
) => {
  const [appSocket, setAppSocket] = React.useState<ISocket>(null);
  const [loading, setLoading] = React.useState(false);
  const { user } = useAuth();
  const { userUuid: user_uuid, role_value: role_value } = user;

  useEffect(() => {
    // Initialize socket - for activation, we don't need user_uuid auth
    // The socket will connect and join the partnerRoom directly
    const newSocket = initializeSocket(user_uuid);
    
    const handleConnect = () => {
      setAppSocket(newSocket);
      (window as any).socket = newSocket;
      console.log("✅ Socket connected:", newSocket.connected, newSocket.id);
    };

    const handleDisconnect = (reason: string) => {
      console.log("❌ Socket disconnected:", reason);
      setAppSocket(null);
    };

    const handleConnectError = (error: Error) => {
      console.error("❌ Socket connection error:", error);
    };

    const handleError = (error: Error) => {
      console.error("❌ Socket error:", error);
    };

    // Set up event listeners
    newSocket.on("connect", handleConnect);
    newSocket.on("disconnect", handleDisconnect);
    newSocket.on("connect_error", handleConnectError);
    newSocket.on("error", handleError);

    // Also try to join room immediately if already connected
    if (newSocket.connected) {
      handleConnect();
    }

    return () => {
      // Clean up event listeners
      newSocket.off("connect", handleConnect);
      newSocket.off("disconnect", handleDisconnect);
      newSocket.off("connect_error", handleConnectError);
      newSocket.off("error", handleError);
      newSocket.disconnect(); // ✅ Cleanup on unmount
    };
  }, [user_uuid]);

  // if ((user_uuid && !appSocket) || loading) return <LinearProgress />;

  return (
    <SocketContext.Provider value={{ socket: appSocket }}>
        <LinesheetDocumetAlert />
        {/* <BulkActivationProgress /> */}
        <AlertSnackbar />
        {props.children}
    </SocketContext.Provider>
  );
};
